export const ENABLE_EXPIRY_TEXT = {
    message: 'Meeting expiration date is',
    id: 'oe.meeting.enableExpiry',
    description: 'Label text for expiry toggle'
};

export const EXPIRY_DAYS_LABEL_TEXT = {
    message: 'Replay available for',
    id: 'oe.meeting.expiryDaysLabel',
    description: 'Label text for days input field'
};

export const EXPIRY_DAYS_PREFIX_TEXT = {
    message: 'Replay available for',
    id: 'oe.meeting.expiryDaysPrefix',
    description: 'Prefix text before days input'
};

export const EXPIRY_DAYS_SUFFIX_TEXT = {
    message: 'days',
    id: 'oe.meeting.expiryDaysSuffix',
    description: 'Suffix text after days input'
};

export const EXPIRY_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.expiryInfoMessage',
    description: 'Info popover message explaining expiry feature',
    message: 'When enabled, this meeting will expire at 23:59 in the event timezone on the specified date, calculated as the number of days after the meeting start date.'
};

export const EXPIRY_DATE_INFO_TEXT = {
    id: 'oe.meeting.expiryDateInfo',
    defaultMessage: 'Meeting will be unavailable after 23:59 {timezone} on {date}',
    description: 'Expiry date information text shown to user'
};

export const EXPIRY_DAYS_REQUIRED_TEXT = {
    id: 'oe.meeting.expiryDaysRequired',
    defaultMessage: 'Replay availability is required when expiry is enabled',
    description: 'Validation error message when days field is empty'
};

export const EXPIRY_DAYS_RANGE_TEXT = {
    id: 'oe.meeting.expiryDaysRange',
    defaultMessage: 'Replay availability must be between 1 and 999 days',
    description: 'Validation error message when days value is out of range'
};

export const EXPIRY_DAYS_DISPLAY_TEXT = {
    id: 'oe.meeting.expiryDaysDisplay',
    defaultMessage: '{days, plural, one {# day} other {# days}}',
    description: 'Display text for expiry days count in blueprint details popup'
};
